import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { PRODUCT_MOCKUP, instantItems, packFeatures, volumes } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-241" data-mp="kw829bpyi6r5">
      <div className="mx-auto max-w-5xl" data-id="element-242" data-mp="kyc5drg171qd">
        <div className="text-center" data-id="element-243" data-mp="put1b7th2ke0">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-244" data-mp="ptrg4aiqshik">
            Was ist enthalten
          </span>
          <h2 className="mx-auto mt-5 max-w-3xl font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-245" data-mp="fx4x7r9z80j6">
            <span aria-hidden="true" data-id="element-246" data-mp="271g1epyex0l">✦ </span>Was steckt im MATHE BEREIT™ Paket?
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-247" data-mp="75mep9pk58mx">
          {packFeatures.map(feature => {
          const Icon = feature.icon;
          return <li key={feature.title} className="flex flex-col rounded-2xl bg-sand px-6 py-7" data-id="element-248" data-mp="3tcb24vatur4x">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-249" data-mp="3ct4m0jux0vvy">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-250" data-mp="37trs5f5mmojv" />
                </span>
                <h3 className="mt-4 font-display text-lg font-bold leading-snug text-ink" data-id="element-251" data-mp="3luvshqxa56qv">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-252" data-mp="3hqwbz8c027xi">{feature.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-16 grid items-center gap-10 rounded-3xl bg-cream p-8 sm:p-10 md:grid-cols-[1fr_auto]" data-id="element-253" data-mp="2p54l4r3w3p3n">
          <div data-id="element-254" data-mp="32wrsblzdei17">
            <h3 className="font-display text-2xl font-black tracking-tight text-ink sm:text-3xl" data-id="element-255" data-mp="32xazq8re9o0z">
              Was bekommst du <span className="italic text-brand" data-id="element-256" data-mp="2y2x1lylcl2sm">sofort?</span>
            </h3>
            <ul className="mt-6 space-y-3" data-id="element-257" data-mp="2adw06vaxmrwu">
              {instantItems.map(item => <li key={item} className="flex items-start gap-3 text-sm text-ink/80" data-id="element-258" data-mp="26d2bhzpo192w">
                  <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-259" data-mp="9c69pjkb3xzy" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 font-display text-lg font-bold italic text-brand" data-id="element-260" data-mp="j2he177wk97d">
              Dir geht nie wieder das Mathe-Material aus.
            </p>
          </div>
          <img src={PRODUCT_MOCKUP} alt="Die 6 Bände von MATHE BEREIT™" className="mx-auto w-52 drop-shadow-[0_18px_24px_rgba(20,17,15,0.22)] sm:w-64" data-id="element-261" data-mp="o3ybesr6hdj7" />
        </div>

        <h3 className="mt-16 text-center font-display text-2xl font-black tracking-tight text-ink sm:text-3xl" data-id="element-262" data-mp="cj9h13bcy8h">
          Die 6 kompletten Bände
        </h3>
        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-263" data-mp="5d74dxunxz7z">
          {volumes.map(volume => {
          const Icon = volume.icon;
          return <li key={volume.number} className="flex items-center gap-4 rounded-2xl bg-sand px-5 py-5" data-id="element-264" data-mp="1gpq4zhqoaagr">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-brand" data-id="element-265" data-mp="317sa3f4b6p5o">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-266" data-mp="2wa8tw9o1w2b3" />
                </span>
                <span data-id="element-267" data-mp="2rhphhg13nd7v">
                  <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-268" data-mp="2rgxng9n5hnjp">
                    Band {volume.number}
                  </span>
                  <span className="mt-0.5 block font-display text-base font-bold leading-snug text-ink" data-id="element-269" data-mp="2hlm7jo00aaad">
                    {volume.title}
                  </span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}